import React, { useMemo } from "react";
import { AnalyticsActionsResponse } from "../../../api/v2/types";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

interface AnalyticsActionsBreakdownProps {
  actions: AnalyticsActionsResponse | null;
}

const AnalyticsActionsBreakdown = ({ actions }: AnalyticsActionsBreakdownProps) => {
  const data = useMemo(() => actions?.actions || [], [actions]);

  if (!data.length) {
    return <p className="text-sm text-muted-foreground">No action breakdown data.</p>;
  }

  return (
    <div className="h-[260px] rounded border p-3">
      <p className="mb-2 text-sm font-semibold">Action breakdown</p>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="action" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="count" fill="#4f46e5" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AnalyticsActionsBreakdown;
